import React from "react";
import ProfilesAndSettings from "views/Config/Profiles/Common";
import DPIPredfinedProfilesModal from "./DpiPredifinedProfilesModal";
import { composedAPI } from "./api";
import dpiComposition from "./composition";
import help from "help/viewDPIProfileConfig.md";
import settingsHelp from "help/viewDPIProfileConfigSettings.md";

const ConfigDPIProfiles = ({ ...settings }) => (
  <>
    <ProfilesAndSettings
      {...dpiComposition}
      {...composedAPI}
      {...settings}
      help={help}
      settingsHelp={settingsHelp}
    />
    <DPIPredfinedProfilesModal />
  </>
);

export default ConfigDPIProfiles;
